import { WordObject } from "../../interfaces/word-object/WordObject";
import {Word} from "./Word";

 export class Adjective extends Word {
    public artikel: any;
    constructor(word: WordObject){
        super(word);
    }
}